<template>
    <article class="w-full col-span-2 shadow-card p-8 rounded-medium flex flex-col items-center">
        <IconCalendar class="w-[65px] h-[65px] mx-auto mb-6" />
        <h1 class="text-lg font-medium mb-2 max-w-[620px]">Book your first free coaching session now</h1>
        <p class="text-sm font-normal mb-auto max-w-[620px]">Achieve results faster by working one-on-one with a Keap expert.<br/>Hurry — spots fill up quickly!</p>
        <footer class="mt-6 w-full">
            <KeapButton :href="bookingUrl" target="_blank" small-expanded data-qa="book-now-button">Book now</KeapButton>
        </footer>
    </article>
</template>

<script>
import IconCalendar from '@/../svg/Icon_Calendar.svg?component';
import KeapButton from '@/Components/KeapButton.vue';

export default {
    components: {
        IconCalendar,
        KeapButton
    },
    computed: {
        bookingUrl() {
            return Keap.env.PARTNER_BOOKING_URL || 'https://keapnow.com/cbbook';
        }
    }
};
</script>

<style lang="postcss" scoped>
</style>
